import * as XLSX from 'xlsx';

const DownloadAttendanceFullExcel = (detailData, companyName, setOpenBackdrop, employeeName) => {
    if (!detailData || !detailData.punches) {
        alert("No data to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        // 1. Prepare Data for Excel
        const formattedData = detailData.punches.map((punch, index) => ({
            "S.No": index + 1,
            "Employee Name": employeeName,
            "Date": detailData.punch_date,
            "Punch Type": punch.type,
            "Time": punch.punch_time ? punch.punch_time.split(' ')[1] : 'N/A',
            "Site Name": punch.site_name || 'N/A',
            "Latitude": punch.latitude,
            "Longitude": punch.longitude,
            "Total Day Hours": detailData.total_working_hours
        }));

        // 2. Create Sheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // 3. Column Widths
        const wscols = [
            { wch: 6 },  { wch: 20 }, { wch: 12 }, { wch: 10 }, 
            { wch: 12 }, { wch: 25 }, { wch: 15 }, { wch: 15 }, { wch: 15 }
        ];
        worksheet['!cols'] = wscols;

        // 4. Workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Punch Details");

        // 5. Save
        XLSX.writeFile(workbook, `${employeeName}_Attendance_${detailData.punch_date}.xlsx`);

    } catch (error) {
        console.error("Excel Error:", error);
        alert("Error generating Excel");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadAttendanceFullExcel;